import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { showConfirmModal } from 'actions/global';
import DataTable from 'components/shared/DataTable';
import { deleteWarrantyPackage } from 'services/warranty-package.service';
import { formatAccessoryWarranty, formatWarrantyMonths } from '../helpers/warrantyPackage';

const WarrantyPeriodTable = (props) => {
  const { onRefresh } = props;
  const dispatch = useDispatch();
  const columns = useMemo(() => [
    {
      header: 'STT',
      classNameHeader: 'bw_text_center',
      classNameBody: 'bw_text_center',
      formatter: (_, index) => index + 1,
    },
    { header: 'Gói bảo hành', accessor: 'package_name' },
    { header: 'Bảo hành sản phẩm', formatter: (item) => formatWarrantyMonths(item.product_months) },
    { header: 'Bảo hành phụ kiện', formatter: (item) => formatAccessoryWarranty(item.accessory_coverage, item.accessory_months) },
    { header: 'Ngày tạo', accessor: 'created_date' },
    { header: 'Người tạo', accessor: 'created_user' },
    {
      header: 'Trạng thái',
      accessor: 'is_active',
      formatter: (item) => item.is_active
        ? <span className='bw_label_outline bw_label_outline_success text-center'>Kích hoạt</span>
        : <span className='bw_label_outline bw_label_outline_danger text-center'>Ẩn</span>,
    },
  ], []);

  const actions = useMemo(() => [
    {
      globalAction: true,
      icon: 'fi fi-rr-plus',
      type: 'success',
      content: 'Thêm mới',
      permission: 'MD_WARRANTYPERIOD_ADD',
      onClick: () => window._$g.rdr('/warranty-package/add'),
    },
    {
      icon: 'fi fi-rr-edit',
      color: 'blue',
      permission: 'MD_WARRANTYPERIOD_EDIT',
      onClick: (item) => window._$g.rdr(`/warranty-package/edit/${item.warranty_package_id}`),
    },
    {
      icon: 'fi fi-rr-eye',
      color: 'green',
      permission: 'MD_WARRANTYPERIOD_VIEW',
      onClick: (item) => window._$g.rdr(`/warranty-package/detail/${item.warranty_package_id}`),
    },
    {
      icon: 'fi fi-rr-trash',
      color: 'red',
      permission: 'MD_WARRANTYPERIOD_DEL',
      onClick: (item) => dispatch(showConfirmModal(
        ['Bạn có thực sự muốn xóa?', 'Không thể xóa gói bảo hành đang được hàng hóa sử dụng.'],
        async () => {
          await deleteWarrantyPackage(item.warranty_package_id);
          onRefresh();
        },
      )),
    },
  ], [dispatch, onRefresh]);

  return <DataTable {...props} columns={columns} actions={actions} />;
};

export default WarrantyPeriodTable;
